import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: 'app-referral-intro-dialog',
  templateUrl: './referral-intro-dialog.component.html',
  standalone: true,
  imports: [MatIcon, MatRipple],
  styles: [`
    :host {
      display: block;
      overflow: hidden;
      border-radius: 1.25rem;
    }
    @keyframes conf-burst {
      0%   { transform: translate(-50%, -50%) rotate(0deg) scale(1); opacity: 1; }
      35%  { transform: translate(calc(-50% + var(--tx)), calc(-50% + var(--ty))) rotate(calc(var(--r) * 0.6)) scale(0.9); opacity: 1; }
      75%  { transform: translate(calc(-50% + var(--tx) * 1.08), calc(-50% + var(--ty) * 1.08 + 18px)) rotate(var(--r)) scale(0.7); opacity: 0.7; }
      100% { transform: translate(calc(-50% + var(--tx) * 1.1), calc(-50% + var(--ty) * 1.1 + 38px)) rotate(calc(var(--r) * 1.3)) scale(0.3); opacity: 0; }
    }
    .conf {
      position: absolute;
      top: var(--oy, 90px);
      left: 50%;
      width: var(--w, 5px);
      height: var(--h, 8px);
      border-radius: 1px;
      background: var(--c, #ffffff);
      animation: conf-burst 2.4s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms) 1 forwards;
      pointer-events: none;
      z-index: 0;
    }
  `],
})
export class ReferralIntroDialogComponent {
  public readonly earningsPotential: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: { referralCode: string; earningsPotential: string },
    private readonly dialogRef: MatDialogRef<ReferralIntroDialogComponent>,
    private readonly router: Router,
  ) {
    this.earningsPotential = data.earningsPotential;
  }

  public onStartReferring(): void {
    this._permanentlyDismiss();
    this.dialogRef.close();
    this.router.navigate(['/home/settings/referral']);
  }

  public onLearnMore(): void {
    window.open('https://referrals.ourpixo.com', '_blank', 'noopener noreferrer');
  }

  public dismiss(): void {
    this.dialogRef.close();
  }

  private _permanentlyDismiss(): void {
    localStorage.setItem(`pixo_referral_intro_${this.data.referralCode}`, 'true');
  }
}
